import * as React from 'react'

import { observer } from 'mobx-react'

import { LabourUnitsResult } from 'modules/timeoff/hooks/useLabourUnits'
import type LeaveDayTypeForm from 'modules/timeoff/lib/LeaveDayTypeForm'
import type LeaveForm from 'modules/timeoff/lib/LeaveForm'
import { DaysTree } from 'modules/timeoff/lib/getDateRangeFromTree'

import Days from './DayTypes/Days'
import HalfDay from './DayTypes/HalfDay'
import Hours from './DayTypes/Hours'

interface Props {
  readOnly: boolean
  form: LeaveForm
  dayTypeForm: LeaveDayTypeForm
  companyHolidaysMuncher: () => DaysTree
  blockedPeriodsMuncher: () => DaysTree
  leavesMuncher: () => DaysTree
  bulkAdd?: boolean
  timeTaken?: string
  labourUnits: LabourUnitsResult
  isReviewOrEditMode?: boolean
}

const DayTypeForm = ({
  readOnly = false,
  form,
  dayTypeForm,
  companyHolidaysMuncher,
  blockedPeriodsMuncher,
  leavesMuncher,
  bulkAdd,
  timeTaken,
  labourUnits,
  isReviewOrEditMode,
}: Props) => {
  const dayType = dayTypeForm.get('day_type').value

  const props = {
    form,
    readOnly,
    holidays: companyHolidaysMuncher(),
    blockedPeriods: blockedPeriodsMuncher(),
    existingLeaves: leavesMuncher(),
    bulkAdd,
    timeTaken,
    labourUnits,
    isReviewOrEditMode,
  }

  switch (dayType) {
    case 'half_day':
      return <HalfDay {...props} />
    case 'hours':
      return <Hours {...props} />

    default:
      return <Days {...props} />
  }
}

export default observer(DayTypeForm)
